<script setup>
import { useColorMode } from "@vueuse/core";
import { computed, ref, watch } from "vue";

import { isNativePlatform } from "../capacitor/platform";
import { getServerUrl } from "../capacitor/server-url";

const mode = useColorMode({
  initialValue: "dark",
});

// The backend serves the company logo (or the default) at this path. On native
// the WebView origin is https://localhost, so a relative path would load the
// bundle's default logo instead of the server's. Prefix the configured server
// URL so the company logo loads cross-origin (the endpoint is a public GET).
const origin = ref("");
if (isNativePlatform()) {
  getServerUrl().then((url) => {
    if (url) origin.value = url.replace(/\/+$/, "");
  });
}

const logoPath = computed(() =>
  mode.value === "light"
    ? "/assets/images/Knocknoc_long_whitebg_Large_purple.png"
    : "/assets/images/Knocknoc_long_darkbg_Large_purple.png",
);
const logo = computed(() => origin.value + logoPath.value);
const needsDarkBackground = ref(false);

watch(
  logo,
  async () => {
    try {
      const response = await fetch(logo.value);
      needsDarkBackground.value = mode.value === "light" && response.headers.get("X-Logo-Type") === "dark";
    } catch {
      needsDarkBackground.value = false;
    }
  },
  {
    immediate: true,
  },
);
</script>

<template>
  <img :class="{ 'bg-black': needsDarkBackground }" :src="logo" alt="Knocknoc logo" />
</template>
